import { Grid, useMediaQuery } from '@material-ui/core';
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import formatters from '../../../../Core/Grid/inputFormatter';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import ReactDOM from 'react-dom';
// import AddDriver from './addDriver';
import DialogComp from '../../../../Core/Modal/dialogModal';
import EditIcon from '@material-ui/icons/Edit';
import AddSalesDriver from './addDriver';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px',
    marginLeft: '11px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Sales', active: true },
    { name: 'Driver', active: true }
];

const baseColumns = [
    { field: 'action', title: 'Action', width: '5%', filterable: false, sortable: false },
    { field: 'name', title: 'Driver Name', filterable: true, sortable: true, width: '20%' },
    { field: 'email', title: 'Email', filterable: true, sortable: true, width: '25%' },
    { field: 'phone', title: 'Phone', filterable: true, sortable: true, width: '15%' },
    { field: 'minRate', title: 'Min Rate', filterable: true, sortable: true, width: '10%' },
    { field: 'mileRate', title: 'Miles Rate', filterable: true, sortable: true, width: '10%' }
];

const SalesDriverListScreen = (props) => {
    const [state, setState] = useState({
        showModal: false,
        DriversObj: {},
        activeSelected: true,
        isReload: ''
    });

    const showAddDriverModal = (row) => {
        setState((prev) => ({ ...prev, showModal: true, selectedDriver: row || {} }));
    };

    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="flex-start" style={{ width: '100%' }}>
                <abbr title="Add Driver">
                    <SquareButton
                        style={{
                            backgroundColor: '#183B68',
                            borderRadius: '20%',
                            width: '32px',
                            height: '32px',
                            textAlign: 'center',
                            padding: '0px 0px 0px 0px',
                            marginLeft: '20px'
                        }}
                        onClick={showAddDriverModal}
                    >
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, row) => {
        const spn = document.createElement('span');

        const lnk = (
            <Grid container justifyContent="flex-start" style={{ width: '100%' }}>
                <abbr title="Edit Loan Vehicle details">
                    {' '}
                    <SquareButton style={styleObj} onClick={() => showAddDriverModal(row)}>
                        <EditIcon fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');
        if (actionCol) {
            actionCol.renderer = editButton({});
        }
        return tempCols;
    }, []);

    const hideAddDriverModal = (res) => {
        let newSt = {};
        newSt.showModal = false;
        newSt.selectedDriver = {};
        if (res) {
            newSt.isReload = new Date();
        }
        setState((st) => ({
            ...st,
            ...newSt
        }));
    };

    const baseUrl = `SalesDriver?IsInternal=${true}`;
    const rowDataStyle = (record) => ({
        'background-color': record.isWorking ? '#dc3545' : 'white'
    });
    const colDataStyle = (record) => ({
        color: record.isWorking ? 'white' : 'black'
    });

    return (
        <div>
            <div className="report-screen-container">
                <Grid container justify="space-between">
                    <Grid item>
                        <BreadCrumbs crumbs={crumbs} />
                    </Grid>
                </Grid>
                <Grid item container spacing={1} xs={12}>
                    <Grid item xs={12}>
                        <ReportGijgoGrid
                            dataConverter={(res) => ({
                                records: res?.data?.list,
                                total: res?.data?.total
                            })}
                            columns={columns}
                            getUrl={baseUrl}
                            AddBtn={addButton}
                            isReload={state.isReload}
                            setRowStyleOnCondition={true}
                            setRowStyleFunction={rowDataStyle}
                            setColStyleOnCondition={true}
                            setColStyleFunction={colDataStyle}
                        />
                    </Grid>
                    {state.showModal ? (
                        <DialogComp
                            onClose={() => hideAddDriverModal(false)}
                            title={`${state.selectedDriver?.id ? 'Update' : 'Add'} Driver`}
                            maxWidth="sm"
                            fullWidth
                        >
                            <AddSalesDriver fromScreen="driver" selectedDriverID={state.selectedDriver?.id || null} onClose={hideAddDriverModal} />
                        </DialogComp>
                    ) : null}
                </Grid>
            </div>
        </div>
    );
};

export default SalesDriverListScreen;
